import "./App.css";
import { RouterProvider } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { useEffect, useState } from "react";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactGA from "react-ga4";
import useCountryCode from "./Hooks/useCountryCode";
import { CommonToast } from "./components/common/Toast";
import { getCountryNameByCountryCode } from "./utils/countriesState";
import { router } from "./router";
import { getConsent, setConsent } from "./utils/cookieConsent";
import { sanitizeAnalyticsPage } from "./utils/sanitizeAnalyticsPath";
import CookieBanner from "./components/CookieBanner";

// TIP-614 — one shared instance. This used to call loadStripe() itself, as
// did both payment forms, so the app ran three Stripe.js instances.
import { stripePromise } from "./utils/stripe";
function App() {
  const { countryCode, loading } = useCountryCode();
  const [accessWeb, setAccessWeb] = useState(true);

  const [consent, setConsentState] = useState(() => getConsent());

  const handleAccept = () => {
    const value = { marketing: true };
    setConsent(value);
    setConsentState(value);
  };

  const handleReject = () => {
    const value = { marketing: false };
    setConsent(value);
    setConsentState(value);
  };

  useEffect(() => {
    const fetchCountryDetails = async () => {
      if (countryCode && !loading) {
        const countryDetails = await getCountryNameByCountryCode(countryCode);
        CommonToast.info(`Default country set to ${countryDetails.name}`)
      }
    };
    fetchCountryDetails();
  }, [countryCode])

  useEffect(() => {
    const env = process.env.REACT_APP_ENVIRONMENT;

    /* ---- Google Analytics ---- */
    if (env === "testing") {
      ReactGA.initialize("G-BXXHYLC766");
    } else if (env === "production") {
      ReactGA.initialize("G-DEZKKH8MFR");
    }

    // TIP-589 — the raw path/href can carry a lead's capability token
    // (e.g. /company-registration/<token>); never send that to GA.
    const { page, title } = sanitizeAnalyticsPage(
      window.location.pathname,
      window.location.search,
      window.location.origin
    );
    ReactGA.send({ hitType: "pageview", page, title });

    /* ---- Microsoft Clarity ---- */
    if (process.env.REACT_APP_MICROSOFT_CLARITY === "true") {
      (function (c, l, a, r, i, t, y) {
        c[a] =
          c[a] ||
          function () {
            (c[a].q = c[a].q || []).push(arguments);
          };
        t = l.createElement(r);
        t.async = 1;
        t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t, y);
      })(window, document, "clarity", "script", "uqe1v51g85");
    }
  }, []);

  useEffect(() => {
    if (localStorage?.getItem("Access_token")) {
      setAccessWeb(false);
    }
  }, []);

  return (
    <>{!consent && (
      <CookieBanner
        onAccept={handleAccept}
        onReject={handleReject}
      />
    )}
      <Elements stripe={stripePromise}>
        <div className="App">
          <RouterProvider router={router} />
          <ToastContainer />
        </div>
      </Elements>
    </>

  );
}

export default App;
